import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { guidFor } from '@ember/object/internals';
import { task, restartableTask, dropTask, timeout } from 'ember-concurrency';
import moment from 'moment-timezone';
import { currency2Number, notifyUserError } from 'beebee-base/lib/utility';
import { debug } from '@ember/debug';
import { beebeeAjaxGet, beebeeAjaxPost, bbParam } from 'beebee-base/lib/utility/ajax';
import { loadScript } from 'beebee-base/lib/utility/load-script';
import getConfig from 'beebee-base/lib/get-config';
import { seedPaymentDate, isPaymentValidForRetry, computeTimeState, buildPaymentEnable, formatLanguageCode, buildSuccessBookingData, payPalLocale, buildPosVirtualeUrl } from '../lib/payment-logic.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

function _applyDecoratedDescriptor(i, e, r, n, l) {
  var a = {};
  return Object.keys(n).forEach(function (i) {
    a[i] = n[i];
  }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) {
    return n(i, e, r) || r;
  }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}
function _initializerDefineProperty(e, i, r, l) {
  r && Object.defineProperty(e, i, {
    enumerable: r.enumerable,
    configurable: r.configurable,
    writable: r.writable,
    value: r.initializer ? r.initializer.call(l) : void 0
  });
}

var TEMPLATE = precompileTemplate("{{#if this.timeOver}}\n  <div class=\'text-center\'>\n    <h3>\n      {{t \'online_payment.time_expired\'}}\n    </h3>\n    <h4>\n      {{t \'online_payment.make_new_reservation\'}}\n    </h4>\n    <br />\n    <button\n      type=\'button\'\n      class=\'button hollow expanded large\'\n      data-test-continue-shop\n      {{on \'click\' this.continueShop}}\n    >\n      {{t \'online_payment.continue_shopping\'}}\n    </button>\n  </div>\n{{else if this.paymentInvalid}}\n  <div class=\'text-center\'>\n    <h3>\n      {{t \'online_payment.project_archived\'}}\n    </h3>\n    <h4>\n      {{t \'online_payment.make_new_reservation\'}}\n    </h4>\n    <br />\n    <button\n      type=\'button\'\n      class=\'button hollow expanded large\'\n      data-test-continue-shop\n      {{on \'click\' this.continueShop}}\n    >\n      {{t \'online_payment.continue_shopping\'}}\n    </button>\n  </div>\n{{else}}\n  {{#if this.getIntegrationTask.isRunning}}\n    <div class=\'text-center\' style=\'padding: 24px 0;\'>\n      <FaIcon @icon=\'spinner\' @spin={{true}} />\n    </div>\n  {{else if this.integrationError}}\n    <div class=\'box-message danger\'>\n      <div class=\'icon\'>\n        <FaIcon @icon=\'circle-exclamation\' />\n      </div>\n      <div class=\'message\'>\n        <div class=\'headline\'>\n          {{t \'online_payment.load_error\'}}\n        </div>\n        <div class=\'description\'>\n          <button\n            type=\'button\'\n            class=\'button small hollow\'\n            data-test-get-integration\n            {{on \'click\' (perform this.getIntegrationTask)}}\n          >\n            {{t \'online_payment.retry\'}}\n          </button>\n        </div>\n      </div>\n    </div>\n  {{else if this.methodExist}}\n    {{#if @payment.total}}\n      {{#if this.tempoRestante}}\n        <div class=\'text-center\'>\n          <h4 class=\'beebeeLabel cardLabel\'>\n            {{t \'time left to pay\'}}\n          </h4>\n          <h3>\n            {{this.tempoRestante}}\n          </h3>\n        </div>\n        <br />\n      {{/if}}\n\n      {{#if this.payment_enable.paypal.enable}}\n        <PaymentMethod::PaymentSection\n          @isSelected={{is-equal this.paymentSelected \'paypal\'}}\n          @onSelect={{fn this.selectService \'paypal\'}} data-test-select-service\n        >\n          <:header>\n            <BbRadio\n              @content={{this.paymentSelected}}\n              @setContent={{this.selectService}}\n              @value=\'paypal\'\n              @name={{t \'paypal\'}}\n              @label={{t \'online_payment.paypal\'}}\n            />\n            <p class=\'description\'>\n              {{t \'online_payment.paypal_description\'}}\n            </p>\n          </:header>\n          <:logo>\n            <img\n              src=\'https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-150px.png\'\n              class=\'paypal-logo\'\n              border=\'0\'\n              alt=\'PayPal\'\n            />\n          </:logo>\n          <:content>\n            <div class=\'payment-button\'>\n              <div id=\'{{this.elementId}}-paypal-button\'></div>\n            </div>\n          </:content>\n        </PaymentMethod::PaymentSection>\n      {{/if}}\n\n      {{#if this.payment_enable.sumup.enable}}\n        <PaymentMethod::PaymentSection\n          @isSelected={{is-equal this.paymentSelected \'sumup\'}}\n          @onSelect={{fn this.selectService \'sumup\'}} data-test-select-service-2\n        >\n          <:header>\n            <BbRadio\n              @content={{this.paymentSelected}}\n              @setContent={{this.selectService}}\n              @value=\'sumup\'\n              @name={{t \'sumup\'}}\n              @label={{t \'online_payment.sumup\'}}\n            />\n            <p class=\'description\'>\n              {{t \'online_payment.sumup_description\'}}\n            </p>\n          </:header>\n          <:logo>\n            <img\n              src=\'https://beebeeassets.beebeeboard.com/img/sumup-logo-black.svg\'\n              class=\'sumup-logo\'\n              border=\'0\'\n              alt=\'Sumup\'\n            />\n          </:logo>\n          <:content>\n            <div class=\'payment-button\'>\n              <div id=\'{{this.elementId}}-sumup-button\'></div>\n            </div>\n          </:content>\n        </PaymentMethod::PaymentSection>\n      {{/if}}\n\n      {{#if this.payment_enable.satispay.enable}}\n        <PaymentMethod::PaymentSection\n          @isSelected={{is-equal this.paymentSelected \'satispay\'}}\n          @onSelect={{fn this.selectService \'satispay\'}} data-test-select-service-3\n        >\n          <:header>\n            <BbRadio\n              @content={{this.paymentSelected}}\n              @setContent={{this.selectService}}\n              @value=\'satispay\'\n              @name={{t \'satispay\'}}\n              @label={{t \'satispay\'}}\n            />\n            <p class=\'description\'>\n              {{t \'online_payment.satispay_description\'}}\n            </p>\n          </:header>\n          <:logo>\n            <img\n              src=\'https://beebeeassets.beebeeboard.com/img/satispay.svg\'\n              class=\'satispay-logo\'\n              border=\'0\'\n              alt=\'Satispay\'\n            />\n          </:logo>\n          <:content>\n            <div class=\'payment-button\'>\n              <button\n                type=\'button\'\n                class=\'button flat {{if this.initSatispay.isRunning \"loading\"}}\'\n                disabled={{this.initSatispay.isRunning}}\n                data-test-init-satispay\n                {{on \'click\' (perform this.initSatispay)}}\n              >\n                <img\n                  src=\'https://beebeeassets.beebeeboard.com/img/{{if\n                    (is-equal (get this.intl.locale \"0\") \"it-it\")\n                    \"it\"\n                    \"en\"\n                  }}-pay-red.svg\'\n                  alt=\'Pay with Satispay\'\n                  style=\'height: 60px;\'\n                />\n              </button>\n            </div>\n          </:content>\n        </PaymentMethod::PaymentSection>\n      {{/if}}\n\n      {{#if this.payment_enable.stripe.enable}}\n        <PaymentMethod::PaymentSection\n          @isSelected={{is-equal this.paymentSelected \'stripe\'}}\n          @onSelect={{fn this.selectService \'stripe\'}} data-test-select-service-4\n        >\n          <:header>\n            <BbRadio\n              @content={{this.paymentSelected}}\n              @setContent={{this.selectService}}\n              @value=\'stripe\'\n              @name={{t \'stripe\'}}\n              @label={{t \'online_payment.credit_card\'}}\n            />\n            <p class=\'description\'>\n              {{t \'online_payment.credit_card_description\'}}\n            </p>\n          </:header>\n          <:logo>\n            {{#unless this.session.option_field.booking_settings.hide_visa}}\n              <img\n                src=\'https://beebeeassets.beebeeboard.com/assets/img/card/1.png\'\n                border=\'0\'\n                class=\'card-img\'\n                alt=\'Visa\'\n              />\n            {{/unless}}\n            {{#unless this.session.option_field.booking_settings.hide_mastercard}}\n              <img\n                src=\'https://beebeeassets.beebeeboard.com/assets/img/card/2.png\'\n                border=\'0\'\n                class=\'card-img\'\n                alt=\'Mastercard\'\n              />\n            {{/unless}}\n            {{#unless this.session.option_field.booking_settings.hide_america_express}}\n              <img\n                src=\'https://beebeeassets.beebeeboard.com/assets/img/card/22.png\'\n                border=\'0\'\n                class=\'card-img\'\n                alt=\'America express\'\n              />\n            {{/unless}}\n            <img\n              src=\'https://beebeeassets.beebeeboard.com/assets/img/powered_by_stripe.png\'\n              border=\'0\'\n              class=\'stripe-logo\'\n              alt=\'Stripe\'\n            />\n          </:logo>\n          <:content>\n            <div class=\'payment-button\'>\n              {{#if this.initStripe.isRunning}}\n                <FaIcon @icon=\'spinner\' @spin={{true}} />\n              {{else if this.stripe_session.id}}\n                <button\n                  type=\'button\'\n                  class=\'button large primary\'\n                  data-test-stripe-redirect\n                  {{on \'click\' this.stripeRedirect}}\n                >\n                  {{t \'online_payment.pay_with_credit_card\'}}\n                </button>\n              {{/if}}\n            </div>\n          </:content>\n        </PaymentMethod::PaymentSection>\n      {{/if}}\n\n      {{#if this.payment_enable.pos_virtuale.enable}}\n        <PaymentMethod::PaymentSection\n          @isSelected={{is-equal this.paymentSelected \'pos_virtuale\'}}\n          @onSelect={{fn this.selectService \'pos_virtuale\'}} data-test-select-service-5\n        >\n          <:header>\n            <BbRadio\n              @content={{this.paymentSelected}}\n              @setContent={{this.selectService}}\n              @value=\'pos_virtuale\'\n              @name={{t \'pos_virtuale\'}}\n              @label={{t \'online_payment.credit_card\'}}\n            />\n            <p class=\'description\'>\n              {{t \'online_payment.credit_card_description\'}}\n            </p>\n          </:header>\n          <:logo>\n            {{#unless this.session.option_field.booking_settings.hide_visa}}\n              <img\n                src=\'https://beebeeassets.beebeeboard.com/assets/img/card/1.png\'\n                border=\'0\'\n                class=\'card-img\'\n                alt=\'Visa\'\n              />\n            {{/unless}}\n            {{#unless this.session.option_field.booking_settings.hide_mastercard}}\n              <img\n                src=\'https://beebeeassets.beebeeboard.com/assets/img/card/2.png\'\n                border=\'0\'\n                class=\'card-img\'\n                alt=\'Mastercard\'\n              />\n            {{/unless}}\n            {{#unless this.session.option_field.booking_settings.hide_america_express}}\n              <img\n                src=\'https://beebeeassets.beebeeboard.com/assets/img/card/22.png\'\n                border=\'0\'\n                class=\'card-img\'\n                alt=\'America express\'\n              />\n            {{/unless}}\n          </:logo>\n          <:content>\n            <div class=\'payment-button\'>\n              <button\n                type=\'button\'\n                class=\'button large primary\'\n                data-test-pos-virtuale-redirect\n                {{on \'click\' this.posVirtualeRedirect}}\n              >\n                {{t \'online_payment.pay_with_credit_card\'}}\n              </button>\n            </div>\n          </:content>\n        </PaymentMethod::PaymentSection>\n      {{/if}}\n\n      {{#if this.payment_enable.stripe_bonifico.enable}}\n        <PaymentMethod::PaymentSection\n          @isSelected={{is-equal this.paymentSelected \'stripe_bonifico\'}}\n          @onSelect={{fn this.selectService \'stripe_bonifico\'}} data-test-select-service-6\n        >\n          <:header>\n            <BbRadio\n              @content={{this.paymentSelected}}\n              @setContent={{this.selectService}}\n              @value=\'stripe_bonifico\'\n              @name=\'stripe_bonifico\'\n              @label={{t \'Bank transfer\'}}\n            />\n            <p class=\'description\'>\n              {{t \'online_payment.bank_transfer_description\'}}\n            </p>\n            {{#if this.payment_enable.stripe_bonifico.dati_banca.testo_personalizzato}}\n              <p class=\'description\'>\n                {{safe-string this.payment_enable.stripe_bonifico.dati_banca.testo_personalizzato}}\n              </p>\n            {{/if}}\n          </:header>\n          <:logo>\n            <img\n              src=\'https://beebeeassets.beebeeboard.com/assets/img/powered_by_stripe.png\'\n              border=\'0\'\n              class=\'stripe-logo\'\n              alt=\'Stripe\'\n            />\n          </:logo>\n          <:content>\n            {{#if (is-equal this.paymentSelected \'stripe_bonifico\')}}\n              <div class=\'box-message warning\'>\n                <div class=\'icon\'>\n                  <FaIcon @icon=\'exclamation-triangle\' />\n                </div>\n                <div class=\'message\'>\n                  <div class=\'headline\'>\n                    {{#if this.payment_enable.stripe_bonifico.dati_banca.testo}}\n                      {{safe-string this.payment_enable.stripe_bonifico.dati_banca.testo}}\n                    {{else}}\n                      {{t \'online_payment.bonstripe_warning\'}}\n                    {{/if}}\n                  </div>\n                </div>\n              </div>\n\n              {{#if this.stripeBonificoMailSent}}\n                <div class=\'box-message success\'>\n                  <div class=\'icon\'>\n                    <FaIcon @icon=\'money-check-dollar\' />\n                  </div>\n                  <div class=\'message\'>\n                    <div class=\'headline\'>\n                      {{t \'online_payment.bank_mail_data\'}}\n                    </div>\n                    <div class=\'description\'>\n                      <p>\n                        <strong>\n                          {{this.payment_enable.stripe_bonifico.dati_banca.banca}}\n                        </strong>\n                        <br />\n                        {{this.payment_enable.stripe_bonifico.dati_banca.filiale}}\n                        <br />\n                        {{this.payment_enable.stripe_bonifico.dati_banca.bank_address.line1}}\n                        {{this.payment_enable.stripe_bonifico.dati_banca.bank_address.line2}},\n                        {{this.payment_enable.stripe_bonifico.dati_banca.bank_address.city}},\n                        {{this.payment_enable.stripe_bonifico.dati_banca.bank_address.postal_code}},\n                        {{this.payment_enable.stripe_bonifico.dati_banca.bank_address.country}}\n                      </p>\n                      <p>\n                        IBAN:\n                        <strong class=\'text-alert\'>\n                          {{this.payment_enable.stripe_bonifico.dati_banca.iban}}\n                        </strong>\n                        <br />\n                        BIC/SWIFT:\n                        <strong class=\'text-alert\'>\n                          {{get this.payment_enable.stripe_bonifico.dati_banca \'bic/swift\'}}\n                        </strong>\n                      </p>\n                      <p>\n                        {{{t \'online_payment.bank_mail_sended\' mail=this.session.me.mail}}}\n                      </p>\n                    </div>\n                    {{#if @payment.option_json.link_redirect_ecommerce}}\n                      {{safe-string @payment.option_json.link_redirect_ecommerce}}\n                    {{else}}\n                      <button\n                        type=\'button\'\n                        class=\'button clear\'\n                        data-test-continue-shop-2\n                        {{on \'click\' this.continueShop}}\n                      >\n                        {{t \'online_payment.continue_shopping\'}}\n                      </button>\n                    {{/if}}\n                  </div>\n                </div>\n              {{else}}\n                <div class=\'payment-button\'>\n                  <button\n                    type=\'button\'\n                    class=\'button large primary\n                      {{if this.setStripeBonificoTask.isRunning \"loading\"}}\'\n                    disabled={{this.setStripeBonificoTask.isRunning}}\n                    data-test-set-stripe-bonifico\n                    {{on \'click\' (perform this.setStripeBonificoTask)}}\n                  >\n                    {{t \'online_payment.stripe_get_bank\'}}\n                  </button>\n                </div>\n              {{/if}}\n            {{/if}}\n          </:content>\n        </PaymentMethod::PaymentSection>\n      {{/if}}\n\n      {{#if this.payment_enable.bonifico.enable}}\n        <PaymentMethod::PaymentSection\n          @isSelected={{is-equal this.paymentSelected \'bonifico\'}}\n          @onSelect={{fn this.selectService \'bonifico\'}} data-test-select-service-7\n        >\n          <:header>\n            <BbRadio\n              @content={{this.paymentSelected}}\n              @setContent={{this.selectService}}\n              @value=\'bonifico\'\n              @name=\'bonifico\'\n              @label={{t \'Bank transfer\'}}\n            />\n            <p class=\'description\'>\n              {{t \'online_payment.bank_transfer_description\'}}\n            </p>\n            {{#if this.payment_enable.bonifico.dati_banca.testo_personalizzato}}\n              <p class=\'description\'>\n                {{safe-string this.payment_enable.bonifico.dati_banca.testo_personalizzato}}\n              </p>\n            {{/if}}\n          </:header>\n          <:logo></:logo>\n          <:content>\n            {{#if this.bonificoMailSent}}\n              <div class=\'callout success\'>\n                <h5>\n                  {{t \'online_payment.booking_completed\'}}\n                </h5>\n                <p>\n                  {{t \'online_payment.bank_mail_sended\' mail=this.session.me.mail}}\n                </p>\n                {{#if @payment.option_json.link_redirect_ecommerce}}\n                  {{safe-string @payment.option_json.link_redirect_ecommerce}}\n                {{else}}\n                  <button\n                    type=\'button\'\n                    class=\'button hollow expanded large\'\n                    data-test-continue-shop-3\n                    {{on \'click\' this.continueShop}}\n                  >\n                    {{t \'online_payment.continue_shopping\'}}\n                  </button>\n                {{/if}}\n              </div>\n            {{else}}\n              <div class=\'payment-button\'>\n                <button\n                  type=\'button\'\n                  class=\'button large primary {{if this.setBonificoTask.isRunning \"loading\"}}\'\n                  disabled={{this.setBonificoTask.isRunning}}\n                  data-test-set-bonifico\n                  {{on \'click\' (perform this.setBonificoTask)}}\n                >\n                  {{t \'online_payment.pay_with_bank_transfer\'}}\n                </button>\n              </div>\n            {{/if}}\n          </:content>\n        </PaymentMethod::PaymentSection>\n      {{/if}}\n\n      {{#if this.payment_enable.in_loco.enable}}\n        <PaymentMethod::PaymentSection\n          @isSelected={{is-equal this.paymentSelected \'in_loco\'}}\n          @onSelect={{fn this.selectService \'in_loco\'}} data-test-select-service-8\n        >\n          <:header>\n            <BbRadio\n              @content={{this.paymentSelected}}\n              @setContent={{this.selectService}}\n              @value=\'in_loco\'\n              @name=\'in_loco\'\n              @label={{t \'on site\'}}\n            />\n            <p class=\'description\'>\n              {{t \'online_payment.pay_on_site_description\'}}\n            </p>\n          </:header>\n          <:logo></:logo>\n          <:content>\n            {{#if this.inLocoMailSent}}\n              <div class=\'callout success\'>\n                <h5>\n                  {{t \'online_payment.booking_completed\'}}\n                </h5>\n                <p>\n                  {{t \'online_payment.bank_mail_sended\' mail=this.session.me.mail}}\n                </p>\n                {{#if @payment.option_json.link_redirect_ecommerce}}\n                  {{safe-string @payment.option_json.link_redirect_ecommerce}}\n                {{else}}\n                  <button\n                    type=\'button\'\n                    class=\'button hollow expanded large\'\n                    data-test-continue-shop-4\n                    {{on \'click\' this.continueShop}}\n                  >\n                    {{t \'online_payment.continue_shopping\'}}\n                  </button>\n                {{/if}}\n              </div>\n            {{else}}\n              <div class=\'payment-button\'>\n                <button\n                  type=\'button\'\n                  class=\'button large primary {{if this.setInLocoTask.isRunning \"loading\"}}\'\n                  disabled={{this.setInLocoTask.isRunning}}\n                  data-test-set-in-loco\n                  {{on \'click\' (perform this.setInLocoTask)}}\n                >\n                  {{t \'online_payment.pay_on_site\'}}\n                </button>\n              </div>\n            {{/if}}\n          </:content>\n        </PaymentMethod::PaymentSection>\n      {{/if}}\n    {{/if}}\n  {{else}}\n    {{#unless @payment.success}}\n      <div class=\'box-message warning\'>\n        <div class=\'icon\'>\n          <FaIcon @icon=\'exclamation-triangle\' />\n        </div>\n        <div class=\'message\'>\n          <div class=\'headline\'>\n            {{t \'no payment available\'}}\n          </div>\n        </div>\n      </div>\n    {{/unless}}\n  {{/if}}\n{{/if}}");

var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20;
let PaymentMethodComponent = (_dec = task({
  drop: true
}), _dec2 = task({
  keepLatest: true
}), _class = class PaymentMethodComponent extends Component {
  get fromBooking() {
    return this.args.status === 'ecommerce';
  }
  get requestBy() {
    return this.args.request_by ?? 41651;
  }

  /* istanbul ignore next -- constructor kicks off the infinite tickTask poll +
     network discovery; not instantiable in a unit test (see payment-method-test.js
     header comment). Covered indirectly at app/chrome level. */
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "notify", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
    _initializerDefineProperty(this, "session", _descriptor5, this);
    this.elementId = guidFor(this);
    this.successBookingUrl = 'https://asset.beebeeboard.com/utility/booking/success_booking.php';
    _initializerDefineProperty(this, "timeOver", _descriptor6, this);
    _initializerDefineProperty(this, "methodExist", _descriptor7, this);
    _initializerDefineProperty(this, "tempoRestante", _descriptor8, this);
    _initializerDefineProperty(this, "startDate", _descriptor9, this);
    _initializerDefineProperty(this, "paymentSelected", _descriptor0, this);
    _initializerDefineProperty(this, "paymentInvalid", _descriptor1, this);
    _initializerDefineProperty(this, "stripe_session", _descriptor10, this);
    _initializerDefineProperty(this, "bonificoMailSent", _descriptor11, this);
    _initializerDefineProperty(this, "stripeBonificoMailSent", _descriptor12, this);
    _initializerDefineProperty(this, "inLocoMailSent", _descriptor13, this);
    // Phase flags: mark the primary write done so a retry after a failed
    // booking-confirmation step does not replay the write (duplicate email/record).
    _initializerDefineProperty(this, "bonificoWritten", _descriptor14, this);
    _initializerDefineProperty(this, "stripeBonificoWritten", _descriptor15, this);
    _initializerDefineProperty(this, "inLocoWritten", _descriptor16, this);
    _initializerDefineProperty(this, "disablePosClick", _descriptor17, this);
    _initializerDefineProperty(this, "stripeTotale", _descriptor18, this);
    _initializerDefineProperty(this, "integrationError", _descriptor19, this);
    _initializerDefineProperty(this, "payment_enable", _descriptor20, this);
    this.disablePosClick = false;
    this.stripeTotale = Math.round(currency2Number(args.payment.total) * 100);

    // Seed the countdown origin BEFORE the first tick. `checkDate()` reads
    // `startDate` and then writes the seeded value back to it, and the first
    // `checkDate()` runs synchronously inside this constructor — i.e. inside the
    // render pass — so on a payment with no `date` that read-then-write threw
    // "You attempted to update 'startDate' ... but it had already been used
    // previously in the same computation" and the payment widget never rendered.
    // Seeding here is a plain write with no prior read, which Glimmer allows.
    if (!args.payment?.date) {
      this.startDate = seedPaymentDate();
    }
    if (!args.payment.success) {
      this.checkPaymentValidity();
    }
    this.tickTask.perform();
  }
  async checkPaymentValidity() {
    let isValid = true;
    try {
      isValid = await isPaymentValidForRetry(this.args.payment);
    } catch (e) {
      // Fail-open: se la validazione retry va in errore non dobbiamo nascondere
      // in silenzio TUTTI i metodi di pagamento (era il caso di projects.toArray()
      // su Ember Data 5, che lasciava paymentInvalid=false e non lanciava mai la GET).
      isValid = true;
    }
    if (!isValid) {
      this.paymentInvalid = true;
      return;
    }
    this.getIntegrationTask.perform();
  }

  /* istanbul ignore next -- teardown for the constructor-only tasks above. */
  willDestroy() {
    super.willDestroy(...arguments);
    // Cancella task async per evitare side-effect su component distrutto
    this.tickTask?.cancelAll?.();
    this.getIntegrationTask?.cancelAll?.();
    this.callSuccessBookingTask?.cancelAll?.();
    this.enableServiceTask?.cancelAll?.();
    // initStripe/Sumup/Paypal are children of enableServiceTask (cancelled by
    // the cascade above), but initSatispay is performed straight from the
    // template ({{on 'click' (perform this.initSatispay)}}), so it is a
    // top-level instance that must be cancelled explicitly — otherwise it keeps
    // running (and derefs this.args.payment) on a destroyed component.
    this.initSatispay?.cancelAll?.();
  }

  /* istanbul ignore next -- wall-clock poll loop; only reachable via the
     constructor, which is intentionally never invoked in unit tests. checkDate()
     itself (the synchronous body this loop calls every second) IS unit tested. */
  *tickTask() {
    // Under test the loop runs exactly once. An ember-concurrency `timeout` keeps
    // a run-loop timer pending for as long as the loop lives, so with a
    // `while (true)` poll `settled()` NEVER resolves: every acceptance test that
    // rendered a payment page died at the 30s cap and no write on those pages
    // could be driven end to end. The countdown itself is wall-clock UI, so
    // ticking once is the faithful thing to do in a frozen test run.
    const isTest = getConfig(this).environment === 'test';
    while (true) {
      if (this.isDestroying || this.isDestroyed) return;
      this.checkDate();
      if (isTest) return;
      yield timeout(1000);
    }
  }
  checkDate() {
    const date = this.args.payment?.date ?? this.startDate;
    // option_field is null until organization options load: keep the 1s tick
    // loop alive instead of throwing and killing the payment countdown.
    const maxTime = this.session.option_field?.booking_payment_timeout || 300;
    const isTimedFlow = this.fromBooking || this.args.booking;
    const {
      timeOver,
      tempoRestante,
      seededDate
    } = computeTimeState({
      date,
      now: moment(),
      maxTime,
      isTimedFlow
    });
    if (seededDate) {
      this.startDate = seededDate;
    }
    this.timeOver = timeOver;
    if (!timeOver && isTimedFlow) {
      this.tempoRestante = tempoRestante;
    }
  }

  /* istanbul ignore next -- fetch network glue; the filter/selection logic it
     delegates to (buildPaymentEnable) is unit tested directly in payment-logic-test.js. */
  *getIntegrationTask() {
    this.integrationError = null;
    const {
      token
    } = this.session;
    const payment = this.args.payment;
    const total = currency2Number(payment.total);
    try {
      const data = yield beebeeAjaxGet(`${getConfig(this).APP.urlApi}/get_pos_method`, token, {
        user_id: this.requestBy
      });
      if (this.isDestroying || this.isDestroyed) return;
      if (!Array.isArray(data)) {
        throw new Error('Invalid get_pos_method response');
      }
      const {
        payment_enable,
        selectedService,
        methodExist
      } = buildPaymentEnable({
        rows: data,
        total,
        fromBooking: this.fromBooking,
        initialPaymentEnable: this.payment_enable
      });
      this.payment_enable = payment_enable;
      this.methodExist = methodExist;
      if (selectedService && !this.paymentSelected) {
        this.paymentSelected = selectedService;
        this.enableServiceTask.perform(selectedService);
      }
    } catch (e) {
      if (this.isDestroying || this.isDestroyed) return;
      this.integrationError = e;
      notifyUserError(this.notify, e, this.intl);
    }
  }

  /* istanbul ignore next -- Stripe network+SDK glue. */
  *initStripe() {
    const orgName = this.session.me?.organization?.name || this.session.me?.organization?.organization;
    try {
      const session = yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/stripe/create_session`, this.session.token, {
        token: this.session.token,
        contact_id: this.session.me?.id,
        user_id: this.requestBy,
        product_name: this.args.productSelected?.name,
        specialista_name: this.args.contactSelected?.name,
        specialista_mail: this.args.contactSelected?.mail,
        start: this.args.applicationController.dateSelected?.start,
        end: this.args.applicationController.dateSelected?.end,
        payment_id: this.args.payment.id,
        organization: orgName,
        total: this.stripeTotale,
        booking: this.args.booking,
        currency: this.session.option_field?.intl?.currency || 'EUR'
      });
      this.stripe_session = session;
      this.payment_enable = {
        ...this.payment_enable,
        stripe: {
          ...this.payment_enable.stripe,
          initDone: true
        }
      };
    } catch (e) {
      notifyUserError(this.notify, e, this.intl);
    }
  }
  formatLanguageCode(languageCode) {
    return formatLanguageCode(languageCode);
  }

  /* istanbul ignore next -- SumUp network+SDK glue. */
  *initSumup() {
    yield timeout(500);
    if (!document.getElementById(`${this.elementId}-sumup-button`)) {
      return false;
    }
    try {
      const session = yield beebeeAjaxGet(`${getConfig(this).APP.urlApi}/sumup/create_checkout`, this.session.token, {
        contact_id: this.session.me?.id,
        user_id: this.requestBy,
        payment_id: this.args.payment.id,
        amount: Math.round(currency2Number(this.args.payment.total) * 100) / 100,
        currency: this.session.option_field?.intl?.currency || 'EUR'
      });
      if (!session.id) {
        return;
      }
      SumUpCard.mount({
        id: `${this.elementId}-sumup-button`,
        locale: this.formatLanguageCode(this.intl.locale?.[0] || 'it-IT'),
        checkoutId: session.id,
        onResponse: (type, body) => {
          if (type === 'success') {
            this.successSumupTask.perform(body);
          }
        }
      });
      this.payment_enable = {
        ...this.payment_enable,
        sumup: {
          ...this.payment_enable.sumup,
          initDone: true
        }
      };
    } catch (e) {
      notifyUserError(this.notify, e, this.intl);
    }
  }

  /* istanbul ignore next -- Satispay network glue + window.location redirect. */
  *initSatispay() {
    yield timeout(500);
    try {
      const session = yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/satispay/create_checkout`, this.session.token, {
        contact_id: this.session.me?.id,
        user_id: this.requestBy,
        payment_id: this.args.payment.id,
        amount: this.stripeTotale,
        currency: this.session.option_field?.intl?.currency || 'EUR',
        product_name: this.args.productSelected?.name,
        specialista_name: this.args.contactSelected?.name,
        specialista_mail: this.args.contactSelected?.mail,
        start: this.args.applicationController.dateSelected?.start,
        end: this.args.applicationController.dateSelected?.end,
        booking: this.args.booking
      });
      if (session.redirect_url) {
        if (typeof this.args.clearItems === 'function') {
          this.args.clearItems();
        }
        window.location.replace(session.redirect_url);
      }
    } catch (e) {
      notifyUserError(this.notify, e, this.intl);
    }
  }

  /* istanbul ignore next -- PayPal SDK glue (global `paypal` object). */
  *initPaypal() {
    const sandBox = this.session.option_field?.test_mode || getConfig(this).APP.paypal.env === 'sandbox';
    yield timeout(500);
    if (!document.getElementById(`${this.elementId}-paypal-button`)) {
      return false;
    }
    const purchase_units = [{
      custom_id: this.args.payment.id,
      custom: this.args.payment.id,
      reference_id: this.args.payment.id,
      amount: {
        value: Math.round(currency2Number(this.args.payment.total) * 100) / 100,
        currency_code: this.session.option_field?.intl?.currency || 'EUR'
      }
    }];
    if (!sandBox && this.session.openOrganization?.organization !== 'poppixsrl') {
      purchase_units[0].payee = {
        email_address: this.payment_enable.paypal.mail,
        merchant_id: this.payment_enable.paypal.merchant_id
      };
    }
    try {
      paypal.Buttons({
        createOrder(data, actions) {
          return actions.order.create({
            purchase_units
          });
        },
        onApprove: (data, actions) => {
          return actions.order.capture().then(details => {
            debug(details);
            if (details.status === 'COMPLETED') {
              this.updatePaypalPayment.perform(details);
            } else {
              this.notify.error(this.intl.t('payment refused'));
            }
          });
        }
      }).render(`#${this.elementId}-paypal-button`);
      this.payment_enable = {
        ...this.payment_enable,
        paypal: {
          ...this.payment_enable.paypal,
          initDone: true
        }
      };
    } catch (e) {
      notifyUserError(this.notify, e, this.intl);
    }
  }

  /* istanbul ignore next -- SumUp verify network glue. */
  *successSumupTask(body) {
    try {
      const verify = yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/sumup/verify`, this.session.token, {
        contact_id: this.session.me?.id,
        user_id: this.requestBy,
        payment_id: this.args.payment.id,
        booking: this.args.booking,
        sumup: body
      });
      if (verify) {
        // redirectAfterPay clears the cart itself; only clear on confirmed
        // verification, never before (a false verify would empty the cart).
        this.redirectAfterPay();
      }
    } catch (e) {
      notifyUserError(this.notify, e, this.intl);
    }
  }

  /* istanbul ignore next -- payment_request_success network glue. */
  *updatePaypalPayment(details) {
    try {
      yield beebeeAjaxGet(`${getConfig(this).APP.urlApi}/payment_request_success`, this.session.token, {
        id: this.args.payment.id,
        success: true,
        payment_method: 'paypal',
        payment_id: details.id,
        date: details.create_time,
        booking: this.args.booking
      });
      if (typeof this.args.clearItems === 'function') {
        this.args.clearItems();
      }
      this.redirectAfterPay();
    } catch (e) {
      // Pagamento PayPal incassato ma conferma backend fallita: logga l'order id per riconciliazione
      debug(`PayPal capture COMPLETED but payment_request_success failed - paypal_order_id=${details?.id} payment_id=${this.args.payment.id}`);
      this.notify.error(this.intl.t('paypal payment taken confirmation failed'));
    }
  }
  redirectAfterPay() {
    if (typeof this.args.clearItems === 'function') {
      this.args.clearItems();
    }
    if (this.args.booking) {
      this.redirectSuccessBooking();
    } else if (this.args.fromScuolesci) {
      // TODO: migrate external PHP endpoint to accept token via POST/header
      /* istanbul ignore next -- window.location navigation side-effect. */
      window.location.replace(`https://${this.session.openOrganization?.organization || ''}.beebeeboard.com/scuolesci_ecommerce/payment_status/${this.args.payment.id}?access_token=${this.session.token}`);
    } else {
      // TODO: migrate external PHP endpoint to accept token via POST/header
      /* istanbul ignore next -- window.location navigation side-effect. */
      window.location.replace(`https://${this.session.openOrganization?.organization || ''}.beebeeboard.com/start/pay_me?request_by=${this.session.me?.id || ''}&payment_id=${this.args.payment.id}&access_token=${this.session.token}`);
    }
  }
  dataSuccessBooking(no_redirect = false) {
    return buildSuccessBookingData({
      session: this.session,
      args: this.args,
      no_redirect
    });
  }

  /* istanbul ignore next -- window.location navigation side-effect. */
  redirectSuccessBooking() {
    window.location.replace(`${this.successBookingUrl}?${bbParam(this.dataSuccessBooking())}`);
  }

  /* istanbul ignore next -- external PHP success-booking network glue. */
  *callSuccessBookingTask() {
    yield beebeeAjaxGet(this.successBookingUrl, this.session.token, this.dataSuccessBooking(true));
    return true;
  }
  payPalLocale(localeStr) {
    return payPalLocale(localeStr);
  }

  /* istanbul ignore next -- loads external PSP SDK scripts + delegates to SDK init tasks. */
  // keepLatest (not drop): with drop, clicking a method while a previous SDK
  // download is in flight silently discarded the selection — the section then
  // rendered without a pay button until the user clicked the same method again.
  // keepLatest lets the in-flight SDK load finish, then initializes the most
  // recently selected service; re-runs are idempotent via the loadJs guards.
  *enableServiceTask(service) {
    let sandBox, queryP;
    try {
      switch (service) {
        case 'paypal':
          sandBox = this.session.option_field?.test_mode || getConfig(this).APP.paypal.env === 'sandbox';
          queryP = {
            'client-id': sandBox ? getConfig(this).APP.paypal.sandBoxId : getConfig(this).APP.paypal.clientId,
            locale: this.payPalLocale(this.intl.primaryLocale),
            currency: this.session.option_field?.intl?.currency || 'EUR'
          };
          if (!this.payment_enable?.paypal?.loadJs) {
            yield loadScript(`https://www.paypal.com/sdk/js?${bbParam(queryP)}`);
            this.payment_enable = {
              ...this.payment_enable,
              paypal: {
                ...this.payment_enable.paypal,
                loadJs: true
              }
            };
          }
          // initDone tracked separately from loadJs: a failed init leaves
          // initDone false so re-selecting retries init without re-loading the SDK.
          if (!this.payment_enable?.paypal?.initDone) {
            yield this.initPaypal.perform();
          }
          break;
        case 'sumup':
          if (!this.payment_enable?.sumup?.loadJs) {
            yield loadScript('https://gateway.sumup.com/gateway/ecom/card/v2/sdk.js');
            this.payment_enable = {
              ...this.payment_enable,
              sumup: {
                ...this.payment_enable.sumup,
                loadJs: true
              }
            };
          }
          if (!this.payment_enable?.sumup?.initDone) {
            yield this.initSumup.perform();
          }
          break;
        case 'stripe':
          if (!this.payment_enable?.stripe?.loadJs) {
            yield loadScript('https://js.stripe.com/v3');
            this.payment_enable = {
              ...this.payment_enable,
              stripe: {
                ...this.payment_enable.stripe,
                loadJs: true
              }
            };
          }
          if (!this.payment_enable?.stripe?.initDone) {
            yield this.initStripe.perform();
          }
          break;
      }
    } catch (e) {
      notifyUserError(this.notify, e, this.intl);
    }
  }

  /* istanbul ignore next -- bonifico network glue. */
  *setBonificoTask() {
    if (!this.args.payment.id || !this.payment_enable.bonifico.enable) {
      return;
    }
    try {
      if (!this.bonificoWritten) {
        yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/${this.args.booking ? 'booking' : 'ecommerce'}_bonifico`, this.session.token, {
          payment_id: this.args.payment.id,
          dati_banca_nome: this.payment_enable.bonifico.dati_banca.nome,
          dati_banca_filiale: this.payment_enable.bonifico.dati_banca.filiale,
          dati_banca_iban: this.payment_enable.bonifico.dati_banca.iban,
          dati_banca_swift: this.payment_enable.bonifico.dati_banca.swift,
          mail: this.session.me?.mail,
          nome: this.session.me?.name,
          importo: parseFloat(Math.round(currency2Number(this.args.payment.total) * 100) / 100).toFixed(2)
        });
        this.bonificoWritten = true;
      }
      if (this.args.booking) {
        yield this.callSuccessBookingTask.perform();
      }
      this.bonificoMailSent = true;
      if (typeof this.args.clearItems === 'function') {
        this.args.clearItems();
      }
    } catch (e) {
      this.args.applicationController?.findError?.(e);
      notifyUserError(this.notify, e, this.intl);
    }
  }

  /* istanbul ignore next -- stripe bonifico network glue. */
  *setStripeBonificoTask() {
    if (!this.args.payment.id || !this.payment_enable.stripe_bonifico.enable) {
      return;
    }
    try {
      if (!this.stripeBonificoWritten) {
        const data = yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/stripe/bonifico`, this.session.token, {
          contact_id: this.session.me?.id,
          user_id: this.payment_enable.stripe_bonifico.user_id,
          payment_id: this.args.payment.id,
          mail: this.session.me?.mail,
          name: this.session.me?.name,
          amount: Math.round(currency2Number(this.args.payment.total) * 100)
        });
        if (data) {
          this.payment_enable = {
            ...this.payment_enable,
            stripe_bonifico: {
              ...this.payment_enable.stripe_bonifico,
              dati_banca: {
                ...this.payment_enable.stripe_bonifico.dati_banca,
                ...data
              }
            }
          };
          this.stripeBonificoMailSent = true;
          this.stripeBonificoWritten = true;
        }
      }
      if (this.args.booking) {
        yield this.callSuccessBookingTask.perform();
      }
      if (typeof this.args.clearItems === 'function') {
        this.args.clearItems();
      }
    } catch (e) {
      this.args.applicationController?.findError?.(e);
      notifyUserError(this.notify, e, this.intl);
    }
  }

  /* istanbul ignore next -- in-loco network glue. */
  *setInLocoTask() {
    if (!this.args.payment.id || !this.payment_enable.in_loco.enable) {
      return;
    }
    try {
      if (!this.inLocoWritten) {
        yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/${this.args.booking ? 'booking' : 'ecommerce'}_in_loco`, this.session.token, {
          payment_id: this.args.payment.id,
          mail: this.session.me?.mail,
          nome: this.session.me?.name,
          importo: parseFloat(Math.round(currency2Number(this.args.payment.total) * 100) / 100).toFixed(2)
        });
        this.inLocoWritten = true;
      }
      if (this.args.booking) {
        yield this.callSuccessBookingTask.perform();
      }
      this.inLocoMailSent = true;
      if (typeof this.args.clearItems === 'function') {
        this.args.clearItems();
      }
    } catch (e) {
      this.args.applicationController?.findError?.(e);
      notifyUserError(this.notify, e, this.intl);
    }
  }
  selectService(service) {
    this.paymentSelected = service;
    this.enableServiceTask.perform(service);
  }
  continueShop() {
    this.router.transitionTo('index');
  }

  /* istanbul ignore next -- global Stripe SDK glue + window redirect. */
  stripeRedirect() {
    if (!this.stripe_session?.id) {
      this.notify.error(this.intl.t('payment not init'));
      return;
    }
    const stripe = Stripe(getConfig(this).APP.stripeToken, {
      stripeAccount: this.stripe_session.stripe_account
    });
    if (typeof this.args.clearItems === 'function') {
      this.args.clearItems();
    }
    stripe.redirectToCheckout({
      sessionId: this.stripe_session.id
    }).then(result => {
      debug(result);
      this.notify.error(this.intl.t('payment not init'));
    });
  }
  posVirtualeRedirect() {
    if (this.disablePosClick) {
      return;
    }
    this.disablePosClick = true;
    if (typeof this.args.clearItems === 'function') {
      this.args.clearItems();
    }

    // TODO: migrate external PHP endpoint to accept token via POST/header
    const url = buildPosVirtualeUrl({
      organization: this.session.openOrganization?.organization,
      contactId: this.session.me?.id,
      paymentId: this.args.payment.id,
      token: this.session.token,
      amount: parseFloat(Math.round(currency2Number(this.args.payment.total) * 100) / 100).toFixed(2)
    });

    /* istanbul ignore next -- window/DOM navigation glue, environment-dependent. */
    if (window.self !== window.top) {
      // Inside an iframe: open the init URL exactly once in a new context
      // (escapes the iframe). The old iframe-probe pattern hit the init
      // endpoint twice (iframe.src + onload navigate), creating duplicate
      // payment sessions. Fall back to top-frame navigation if popup blocked.
      const popup = window.open(url, '_blank');
      if (!popup) {
        window.location.replace(url);
      }
    } else {
      /* istanbul ignore next -- window.location navigation side-effect. */
      window.location.replace(url);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "notify", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "timeOver", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "methodExist", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "tempoRestante", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "startDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "paymentSelected", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "paymentInvalid", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "stripe_session", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "bonificoMailSent", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "stripeBonificoMailSent", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "inLocoMailSent", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "bonificoWritten", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "stripeBonificoWritten", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "inLocoWritten", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "disablePosClick", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "stripeTotale", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "integrationError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "payment_enable", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      paypal: {
        enable: false,
        mail: null,
        data: null
      },
      sumup: {
        enable: false,
        mail: null,
        data: null
      },
      satispay: {
        enable: false,
        mail: null,
        data: null
      },
      stripe: {
        enable: false,
        data: null
      },
      pos_virtuale: {
        enable: false,
        data: null
      },
      bonifico: {
        enable: false,
        dati_banca: null
      },
      stripe_bonifico: {
        enable: false,
        dati_banca: null,
        user_id: null
      },
      in_loco: {
        enable: false
      }
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "tickTask", [restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "tickTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getIntegrationTask", [restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "getIntegrationTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initStripe", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "initStripe"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initSumup", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "initSumup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initSatispay", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "initSatispay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initPaypal", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "initPaypal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "successSumupTask", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "successSumupTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updatePaypalPayment", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "updatePaypalPayment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "callSuccessBookingTask", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "callSuccessBookingTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableServiceTask", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "enableServiceTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setBonificoTask", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "setBonificoTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setStripeBonificoTask", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "setStripeBonificoTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setInLocoTask", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "setInLocoTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectService", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectService"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "continueShop", [action], Object.getOwnPropertyDescriptor(_class.prototype, "continueShop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stripeRedirect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "stripeRedirect"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "posVirtualeRedirect", [action], Object.getOwnPropertyDescriptor(_class.prototype, "posVirtualeRedirect"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, PaymentMethodComponent);

export { PaymentMethodComponent as default };
//# sourceMappingURL=payment-method.js.map
